// src/Admin/ConfirmDialog.jsx — small confirm popup used by the admin inbox screens
import React from 'react';
import { Modal } from 'react-bootstrap';

const ConfirmDialog = ({ show, title, children, confirmLabel = 'Delete', busy = false, onConfirm, onCancel }) => (
  <Modal show={show} onHide={onCancel} centered className="adm-modal">
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    <Modal.Footer>
      <button className="adm-btn adm-btn--ghost" onClick={onCancel} disabled={busy}>Cancel</button>
      <button className="adm-btn adm-btn--danger" onClick={onConfirm} disabled={busy}>
        {busy ? 'Working…' : confirmLabel}
      </button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmDialog;
